import { render } from "./ForceSubmissionModal.vue?vue&type=template&id=7bfb2445&ts=true"
import script from "./ForceSubmissionModal.vue?vue&type=script&lang=ts"
export * from "./ForceSubmissionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__